import { AddressField } from "./AddressForm";

export type AddressModel = {
  firstName?: string;
  lastName?: string;
  address1: string;
  address2?: string;
  city: string;
  region: string;
  postcode: string;
  country: string;
  phone?: string;
};

// Used to define where each component of the billing address should be placed for a given country
export const addressRowCountryMap: Record<string, (keyof AddressModel)[][]> = {
  US: [
    ["country"],
    ["address1"],
    ["address2"],
    ["city"],
    ["region", "postcode"],
  ],
  CA: [
    ["country"],
    ["address1"],
    ["address2"],
    ["city"],
    ["region", "postcode"],
  ],
  // Per @julia: For most International Countries OneSource tax calculation is based on the Country.
  // The region and postal codes are nice to have for the UK, however for tax calculation, we only
  // need the Country. However there are some Countries like Canada and India that do require
  // regional data because the VAT return is broken down by region.
  GB: [["country"], ["address1"], ["address2"], ["city", "region", "postcode"]],
  IE: [["country"], ["address1"], ["address2"], ["city", "region", "postcode"]],
  NZ: [["country"], ["address1"], ["address2"], ["city", "region", "postcode"]],
  AU: [["country"], ["address1"], ["address2"], ["postcode", "city", "region"]],
  default: [
    ["country"],
    ["address1"],
    ["address2"],
    ["city", "region", "postcode"],
  ],
};

export function countryHasRegionField(countryCode: string) {
  return getAddressFormCountryConfig(countryCode).some((fields) =>
    fields.includes("region")
  );
}

export function getAddressFormCountryConfig(countryCode: string) {
  const countryConfig =
    addressRowCountryMap[countryCode?.toUpperCase()] ||
    addressRowCountryMap.default;

  return [["firstName", "lastName"], ...countryConfig] as AddressField[][];
}
